import { render } from "./TrolleyBox.vue?vue&type=template&id=c237fb94&scoped=true"
import script from "./TrolleyBox.vue?vue&type=script&lang=js"
export * from "./TrolleyBox.vue?vue&type=script&lang=js"

import "./TrolleyBox.vue?vue&type=style&index=0&id=c237fb94&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c237fb94"]])

export default __exports__